import type { NotarioModel, StrapiResponseModel } from '@/interfaces/model';
import type { Notario, StrapiListResponse } from '@/interfaces/strapi';

export const notarioMapper = (n: NotarioModel): Notario => ({
	id: n.documentId,
	name: n.name,
	surname: n.surname,
	external_code: n.external_code,
	codigoPostalNotaria: n.codigoPostalNotaria,
	notariaAddress: n.notariaAddress,
	notariaMunicipio: n.notariaMunicipio,
	notariaPoblacion: n.notariaPoblacion,
	notariaProvincia: n.notariaProvincia,
	provinciaDistrito: n.provinciaDistrito,
	provinciaColegio: n.provinciaColegio,
	telefonoNotaria1: n.telefonoNotaria1,
	telefonoNotaria2: n.telefonoNotaria2,
	faxNotaria: n.faxNotaria,
	emailCorporativo: n.emailCorporativo,
	active: n.active,
});

export const notariosListMapper = (res: StrapiResponseModel<NotarioModel>): StrapiListResponse<Notario> => {
	const list = (res.data ?? []).map(notarioMapper);

	const pagination = res.meta?.pagination ?? {
		page: 1,
		pageSize: list.length,
		pageCount: 1,
		total: list.length,
	};

	return { list, pagination };
};
